import { useEffect, useRef } from "react";
import { Animated } from "react-native";
import { DOT_TRANSITION_DURATION } from "./constants";

export default function useSpotlightDotsAnimation(
  total: number,
  activeIndex: number
) {
  const progressRefs = useRef<Animated.Value[]>([]);
  if (progressRefs.current.length !== total) {
    progressRefs.current = Array.from(
      { length: total },
      (_, index) => new Animated.Value(index === activeIndex ? 1 : 0)
    );
  }

  useEffect(() => {
    Animated.parallel(
      progressRefs.current.map((progress, index) =>
        Animated.timing(progress, {
          toValue: index === activeIndex ? 1 : 0,
          duration: DOT_TRANSITION_DURATION,
          useNativeDriver: false,
        })
      )
    ).start();
  }, [activeIndex]);

  return progressRefs.current;
}
